import { FC } from 'react';
import { Title, Subtitle, ModalWrapper } from './style';
import { FlexBox } from '@brg/ui';
import { ExploreButtonFilled, ExploreButtonHollow } from 'shared/pages/explore/styles';
import { useTranslation } from 'react-i18next';

export const ProjectPublishModal: FC<{ onClick: (val: boolean) => void }> = ({ onClick }) => {
    const { t } = useTranslation();

    return (
        <ModalWrapper>
            <FlexBox width={'100%'} widthMobile={'100%'} gyMobile={40} direction='column' directionMobile='column' justify='center' justifyMobile='center'>
                <FlexBox gyMobile={8} direction='column' directionMobile='column' justify='center' justifyMobile='center'>
                    <Title>{t('project_edit.publishModal.title')}</Title>
                    <Subtitle>{t('project_edit.publishModal.subtitle')}</Subtitle>
                </FlexBox>
                <FlexBox gyMobile={8} direction='column' directionMobile='column' justify='center'>
                    <ExploreButtonHollow onClick={() => onClick(false)}>
                        {t('project_edit.publishModal.buttons.cancel')}
                    </ExploreButtonHollow>
                    <ExploreButtonFilled onClick={() => onClick(true)}>
                        {t('project_edit.publishModal.buttons.save')}
                    </ExploreButtonFilled>
                </FlexBox> 
            </FlexBox>
        </ModalWrapper>
    )
}import { FC } from 'react';
import { Title, Subtitle, ModalWrapper } from './style';
import { FlexBox } from '@brg/ui';
import { ExploreButtonFilled, ExploreButtonHollow } from 'shared/pages/explore/styles';
import { useTranslation } from 'react-i18next';

export const ProjectPublishModal: FC<{ onClick: (val: boolean) => void }> = ({ onClick }) => {
    const { t } = useTranslation();

    return (
        <ModalWrapper>
            <FlexBox width={'100%'} widthMobile={'100%'} gyMobile={40} direction='column' directionMobile='column' justify='center' justifyMobile='center'>
                <FlexBox gyMobile={8} direction='column' directionMobile='column' justify='center' justifyMobile='center'>
                    <Title>{t('project_edit.publishModal.title')}</Title>
                    <Subtitle>{t('project_edit.publishModal.subtitle')}</Subtitle>
                </FlexBox>
                <FlexBox gyMobile={8} direction='column' directionMobile='column' justify='center'>
                    <ExploreButtonHollow onClick={() => onClick(false)}>
                        {t('project_edit.publishModal.buttons.cancel')}
                    </ExploreButtonHollow>
                    <ExploreButtonFilled onClick={() => onClick(true)}>
                        {t('project_edit.publishModal.buttons.save')}
                    </ExploreButtonFilled>
                </FlexBox> 
            </FlexBox>
        </ModalWrapper>
    )
}